<template>
  <layout-horizontal>
    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <app-navbar-horizontal-layout-brand />
      <app-navbar-horizontal-layout :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

    <popup-handler slot="popup" />
  </layout-horizontal>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import AppNavbarHorizontalLayoutBrand from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue'
import AppNavbarHorizontalLayout from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue'
import PopupHandler from '@/components/Popup/PopupHandler.vue'

export default {
  components: {
    LayoutHorizontal,
    AppCustomizer,
    AppNavbarHorizontalLayoutBrand,
    AppNavbarHorizontalLayout,
    PopupHandler,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
